const FeatureData = [
    {
        id:1,
        title:"Smart System",
        createdDate:"16/01/2014",
        content:"A smart system is a system provided for those of you who need guidance and who have unlimited activites.",
        imageUrl:"../../images/feature-img.png",
    },
    {
        id:2,

        title:"Free To Use",
        createdDate:"16/01/2014",
        content:"A smart system is a system provided for those of you who need guidance and who have unlimited activites.",
        imageUrl:"../../images/feature-img.png",
    },
    {
        id:3,
        title:"Monitor Transactions",
        createdDate:"16/01/2014",
        content:"A smart system is a system provided for those of you who need guidance and who have unlimited activites.",
        imageUrl:"../../images/feature-img.png",
    },
    {
        id:4,
        title:"Teamwork",
        createdDate:"16/01/2014",
        content:"A smart system is a system provided for those of you who need guidance and who have unlimited activites.",
        imageUrl:"../../images/feature-img.png",
    }
]

export default FeatureData;